import React, { useCallback, useState, useEffect } from 'react';
import { Field, getIn } from 'formik';
import { TimePicker } from 'formik-material-ui-pickers';
import moment from 'moment';

const CustomerTimePicker = (props: any) => {
  const {
    form: { setFieldValue, values },
    field: { name },
  } = props;
  const [value, setValue] = useState();
  const handleOnChange = useCallback(
    (date) => {
      setValue(date);
      setFieldValue(name, moment(date).format('HH:mm'));
    },
    [setFieldValue, name]
  );

  useEffect(() => {
    if (!value) {
      const time: string = getIn(values, name);
      const initialTime = moment();
      if (time && typeof time === 'string') {
        const [hour = 0, minute = 0] = time.split(':');
        initialTime.set({ hour: +hour, minute: +minute });
      }
      handleOnChange(initialTime.toDate());
    }
  }, [values, name, value, handleOnChange]);

  return <TimePicker {...props} onChange={handleOnChange} value={value} />;
};

export const TimeField = (props: any) => (
  <Field
    {...props}
    component={CustomerTimePicker}
    variant="inline"
    inputVariant="outlined"
    format="HH:mm"
    ampm={false}
  />
);

export default TimeField;
